import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Merheje Argentina - Herramientas de Manicura y Cuidado Personal",
      description:
        "Somos distribuidores oficiales de Merheje en Argentina. Encontrá alicates, cortauñas y accesorios de belleza de calidad profesional para mayoristas y uso personal.",
    },
  },
  {
    path: "/donde-encontrarnos",
    name: "donde-encontrarnos",
    component: () =>
      import(/* webpackChunkName: "locations" */ "../views/LocationsView.vue"),
    meta: {
      title: "Donde Encontrarnos - Merheje Argentina",
      description:
        "Encontrá los puntos de venta de Merheje en Argentina. Locales en CABA, Zona Oeste, Zona Sur, Zona Norte, Neuquén y Entre Ríos.",
    },
  },
  {
    path: "/merheje",
    name: "merheje",
    component: () =>
      import(/* webpackChunkName: "brand" */ "../views/BrandView.vue"),
    props: {
      brandName: "merheje",
      brandColor: "#fff",
      backgroundColor1: "#da1884",
      backgroundColor2: "#8e89c1",
      contrastColor: "#512d6c",
      textColor: "#fff",
      categories: ["super", "basic", "pro", "touch", "teens super"],
    },
    meta: {
      title: "Productos Merheje - Calidad y Diseño en Manicura",
      description:
        "Descubrí la línea completa Merheje: Basic, Pro, Touch y más. Herramientas de acero inoxidable y precisión para el cuidado de tus uñas.",
    },
  },
  {
    path: "/curvex",
    name: "curvex",
    component: () =>
      import(/* webpackChunkName: "curvex" */ "../views/BrandView.vue"),
    props: {
      brandName: "curvex",
      brandColor: "#10060c",
      backgroundColor1: "#fae100",
      backgroundColor2: "#ffffff",
      contrastColor: "#10060c",
      textColor: " #10060c",
      categories: [],
    },
    meta: {
      title: "Curvex - Realza tu Mirada",
      description:
        "Arqueadores de pestañas y accesorios de belleza Curvex. Lográ una mirada impactante con productos diseñados para vos.",
    },
  },
  {
    path: "/unhex",
    name: "unhex",
    component: () =>
      import(/* webpackChunkName: "unhex" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      brandColor: "#a5d542",
      backgroundColor1: "#111111",
      backgroundColor2: "#333333",
      contrastColor: "#a5d542",
      textColor: "#ffffff",
      categories: ["baby", "ergomax", "sport", "x-poly", "x-spring"],
    },
    meta: {
      title: "Unhex - Cuidado Personal para Toda la Familia",
      description:
        "Línea Unhex: Productos seguros y precisos para bebés, deportistas y el cuidado diario. Calidad garantizada.",
    },
  },
  {
    path: "/merheje-basic",
    name: "merheje-basic",
    component: () =>
      import(/* webpackChunkName: "merheje-basic" */ "../views/BrandView.vue"),
    props: {
      brandName: "merheje",
      categoryName: "basic",
      subcategoryName: "basic",
      brandColor: "#3d2768",
      backgroundColor1: "#a698bc",
      backgroundColor2: "#f7d7a1",
      contrastColor: "#3d2768",
      textColor: "#f7d7a1",
    },
    meta: {
      title: "Merheje Basic - Merheje Argentina",
      description:
        "Productos de la línea Basic de Merheje. Calidad y diseño pensados para el cuidado personal.",
    },
  },
  {
    path: "/merheje-pro",
    name: "merheje-pro",
    component: () =>
      import(/* webpackChunkName: "merheje-pro" */ "../views/BrandView.vue"),
    props: {
      brandName: "merheje",
      categoryName: "pro",
      subcategoryName: "pro",
      brandColor: "#ec662b",
      backgroundColor1: "#f7d7a1",
      backgroundColor2: "#d3a24fff",
      contrastColor: "#ec662b",
      textColor: "#3d2768",
    },
    meta: {
      title: "Merheje Pro - Merheje Argentina",
      description:
        "Productos de la línea Pro de Merheje. Herramientas profesionales para manicura.",
    },
  },
  {
    path: "/merheje-touch",
    name: "merheje-touch",
    component: () =>
      import(/* webpackChunkName: "merheje-touch" */ "../views/BrandView.vue"),
    props: {
      brandName: "merheje",
      categoryName: "touch",
      subcategoryName: "touch",
      brandColor: "#9dfcfd",
      backgroundColor1: "#ec9dcd",
      backgroundColor2: "#9dfcfd",
      contrastColor: "#fff",
      textColor: "#3d2768",
    },
    meta: {
      title: "Merheje Touch - Merheje Argentina",
      description:
        "Productos de la línea Touch de Merheje. Diseño ergonómico y colores vibrantes.",
    },
  },
  {
    path: "/merheje-teens-super",
    name: "merheje-teens-super",
    component: () =>
      import(
        /* webpackChunkName: "merheje-teens-super" */ "../views/BrandView.vue"
      ),
    props: {
      brandName: "merheje",
      categoryName: "teens-super",
      subcategoryName: "teens-super",
      brandColor: "#ce4895",
      backgroundColor1: "#ffffff",
      backgroundColor2: "#95cfdf",
      contrastColor: "#ce4895",
      textColor: "#3d2768",
    },
    meta: {
      title: "Merheje Teens Super - Merheje Argentina",
      description:
        "Productos de la línea Teens Super de Merheje. Estilo y diversión para el cuidado de tus uñas.",
    },
  },
  {
    path: "/merheje-super",
    name: "merheje-super",
    component: () =>
      import(/* webpackChunkName: "merheje-super" */ "../views/BrandView.vue"),
    props: {
      brandName: "merheje",
      categoryName: "super",
      subcategoryName: "super",
      brandColor: "#3d2768",
      backgroundColor1: "rgba(244, 210, 235, 1)",
      backgroundColor2: "#a6e1efff",
      contrastColor: "#3d2768",
      textColor: "#ce4895",
    },
    meta: {
      title: "Merheje Super - Merheje Argentina",
      description:
        "Productos de la línea Super de Merheje. La mejor calidad para tus manos.",
    },
  },
  {
    path: "/unhex-baby",
    name: "unhex-baby",
    component: () =>
      import(/* webpackChunkName: "unhex-baby" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      categoryName: "baby",
      subcategoryName: "baby",
      brandColor: "#a5d542",
      backgroundColor1: "#ffeaa7",
      backgroundColor2: "#74b9ff",
      contrastColor: "#2d3436",
      textColor: "#2d3436",
    },
    meta: {
      title: "Unhex Baby - Merheje Argentina",
      description:
        "Productos de la línea Unhex Baby. Cuidado delicado y seguro para tu bebé.",
    },
  },
  {
    path: "/unhex-ergomax",
    name: "unhex-ergomax",
    component: () =>
      import(/* webpackChunkName: "unhex-ergomax" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      categoryName: "ergomax",
      subcategoryName: "ergomax",
      brandColor: "white",
      backgroundColor1: "#000000ff",
      backgroundColor2: "#242424ff",
      contrastColor: "#a5d542",
      textColor: "#fff",
    },
    meta: {
      title: "Unhex Ergomax - Merheje Argentina",
      description:
        "Productos de la línea Unhex Ergomax. Máxima ergonomía y precisión.",
    },
  },
  {
    path: "/unhex-sport",
    name: "unhex-sport",
    component: () =>
      import(/* webpackChunkName: "unhex-sport" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      categoryName: "sport",
      subcategoryName: "sport",
      brandColor: "white",
      backgroundColor1: "#000000ff",
      backgroundColor2: "#242424ff",
      contrastColor: "#a5d542",
      textColor: "#fff",
    },
    meta: {
      title: "Unhex Sport - Merheje Argentina",
      description:
        "Productos de la línea Unhex Sport. Diseñados para acompañar tu ritmo de vida.",
    },
  },
  {
    path: "/unhex-x-poly",
    name: "unhex-x-poly",
    component: () =>
      import(/* webpackChunkName: "unhex-x-poly" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      categoryName: "x-poly",
      subcategoryName: "x-poly",
      brandColor: "white",
      backgroundColor1: "#000000ff",
      backgroundColor2: "#242424ff",
      contrastColor: "#a5d542",
      textColor: "#fff",
    },
    meta: {
      title: "Unhex X-Poly - Merheje Argentina",
      description:
        "Productos de la línea Unhex X-Poly. Innovación y resistencia.",
    },
  },
  {
    path: "/unhex-x-spring",
    name: "unhex-x-spring",
    component: () =>
      import(/* webpackChunkName: "unhex-x-spring" */ "../views/BrandView.vue"),
    props: {
      brandName: "unhex",
      categoryName: "x-spring",
      subcategoryName: "x-spring",
      brandColor: "white",
      backgroundColor1: "#000000ff",
      backgroundColor2: "#242424ff",
      contrastColor: "#a5d542",
      textColor: "#fff",
    },
    meta: {
      title: "Unhex X-Spring - Merheje Argentina",
      description:
        "Productos de la línea Unhex X-Spring. Tecnología avanzada para el cuidado personal.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
